import { Zap } from "lucide-react";

export const Logo = ({ className = "", dark = false, size = "md" }) => {
  const sizes = { sm: "text-lg", md: "text-xl", lg: "text-2xl" };
  const icon = { sm: "h-7 w-7", md: "h-9 w-9", lg: "h-10 w-10" };
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <div className={`${icon[size]} rounded-xl bg-gradient-to-tr from-pink-500 via-fuchsia-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-indigo-500/25`}>
        <Zap className="h-1/2 w-1/2 text-white" fill="white" strokeWidth={2.5} />
      </div>
      <span className={`font-heading font-extrabold tracking-tight leading-none ${sizes[size]} ${dark ? "text-white" : "text-slate-900"}`}>
        Aumenta<span className="text-indigo-600">Ya</span>
      </span>
    </div>
  );
};
